import React, { useState, useContext } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { Button, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext.js';
import { Context } from "../../contexts/siteContext.js";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import AlertDialog from '../../common/alertDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function Addunit(props) {
    const classes = useStyles();
    const Id = props.model.length === 0 ? 0 : props.model.Id;
    const action = props.model.length === 0 ? "Add" : "Edit";
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [unitName, setUnitName] = useState(props.model.length === 0 ? '' : props.model.UnitName);
    const [backDrop, setBackDrop] = useState(false);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const alertClose = () => {
        setAlertOpen(false);
    };

    const saveUnit = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (modified && unitName !== "") {
            setBackDrop(true);
            HttpService.post('/Unit/SaveUnit', {
                Id: Id,
                UnitName: unitName,
                SiteCode: defaultSite.id
            })
                .then((result) => {
                    if (result.error) {
                        setBackDrop(false);
                        setErrorMessage(result.message);
                        setSeverity('error');
                        setAlertOpen(true);
                    }
                    else {
                        props.refreshGrid(result.data);
                        props.parentCallback();
                    }
                },
                    (error) => {
                        console.log(error);
                    });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };
        
    return (<>
        <GridContainer style={{ justifyContent: 'center' }}>
            <Backdrop className={classes.backdrop} id="unitAddBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => saveUnit(true)} aria-label="back">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                    <Grid container direction="row" alignItems="center">
                        <Grid item>
                            <Typography variant="h6" className={classes.title}>{action} Unit</Typography>
                        </Grid>
                        <Grid item>
                            <StatusIcon />
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end">
                        <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                            <CloseIcon />
                        </Fab>
                        <SmallMenu modified={modified} saveCallback={() => saveUnit(false)} />
                    </Grid>
                </Toolbar>
            </AppBar>
            <GridItem xs={6} sm={6} md={6} >
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => saveUnit(false)} style={{ width: "100%", display: "block" }}>
                            <TextValidator
                                label="Unit Name"
                                placeholder="Unit Name"
                                name="UnitName"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                variant="outlined"
                                required
                                value={unitName}
                                onChange={(e) => {
                                    setUnitName(e.target.value);
                                    setModified(true);
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                style={{ width: "100%" }}
                            />                           
                            <br /><br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
    </>
    );
}
